import { ChartStyle } from '@/interfaces/chart';

export interface SimpleFrontendChartStyle {
  name: string;
  htmlSanitizedName: string;
  recid: number;
  searchTags: string[];
  styleCacheId: string;
  styleCacheSettingsOverrides: Partial<ChartStyle>,
  temporaryName: string;
  thumbnailUrl: string;
  chartStyleButtonIndex: number;
  chartStyleButtonBackgroundColorHexCode: string;
  chartStyleButtonTextColorHexCode: string;
  chartStyleButtonLabel: string;
  description: string;
  isForPayingMembersOnly: boolean;
}

export function isSimpleFrontendChartStyle(unknownValue: unknown): unknownValue is SimpleFrontendChartStyle {
  return (
    typeof unknownValue === 'object' &&
    unknownValue !== null &&
    'name' in unknownValue &&
    'htmlSanitizedName' in unknownValue &&
    'recid' in unknownValue &&
    'searchTags' in unknownValue &&
    'styleCacheId' in unknownValue &&
    'styleCacheSettingsOverrides' in unknownValue &&
    'temporaryName' in unknownValue &&
    'thumbnailUrl' in unknownValue &&
    'chartStyleButtonIndex' in unknownValue &&
    'chartStyleButtonBackgroundColorHexCode' in unknownValue &&
    'chartStyleButtonTextColorHexCode' in unknownValue &&
    'chartStyleButtonLabel' in unknownValue &&
    'description' in unknownValue &&
    'isForPayingMembersOnly' in unknownValue &&
    typeof unknownValue.name === 'string' &&
    typeof unknownValue.htmlSanitizedName === 'string' &&
    typeof unknownValue.recid === 'number' &&
    Array.isArray(unknownValue.searchTags) &&
    unknownValue.searchTags.every((searchTag: any) => typeof searchTag === 'string') &&
    typeof unknownValue.styleCacheId === 'string' &&
    typeof unknownValue.styleCacheSettingsOverrides === 'object' &&
    unknownValue.styleCacheSettingsOverrides !== null &&
    typeof unknownValue.temporaryName === 'string' &&
    typeof unknownValue.thumbnailUrl === 'string' &&
    typeof unknownValue.chartStyleButtonIndex === 'number' &&
    typeof unknownValue.chartStyleButtonBackgroundColorHexCode === 'string' &&
    typeof unknownValue.chartStyleButtonTextColorHexCode === 'string' &&
    typeof unknownValue.chartStyleButtonLabel === 'string' &&
    typeof unknownValue.description === 'string' &&
    typeof unknownValue.isForPayingMembersOnly === 'boolean'
  );
}

export interface SimpleFrontendSampleChartStyle extends SimpleFrontendChartStyle {
  rootSymbol: string;
  shouldLoadRootSymbol: boolean;
}

export function isSimpleFrontendSampleChartStyle(simpleFrontendChartStyle: SimpleFrontendChartStyle): simpleFrontendChartStyle is SimpleFrontendSampleChartStyle {
  return (
    'rootSymbol' in simpleFrontendChartStyle &&
    'shouldLoadRootSymbol' in simpleFrontendChartStyle &&
    typeof simpleFrontendChartStyle.rootSymbol === 'string' &&
    typeof simpleFrontendChartStyle.shouldLoadRootSymbol === 'boolean'
  );
}

export interface SampleChartStyleGroup {
  name: string;
  recid: number;
  areSavedCharts: boolean;
  charts: SimpleFrontendSampleChartStyle[];
}
